<template>
    <div id="billing-wizard">
        <div class="setup">
            <div class="header">
                <div class="title">
                    <div class="plan-steps">
                        Plan Seçimi İlerlemesi <span>{{ `${activeIndex + 1}/${stepperData.length}` }}</span>
                    </div>
                    <div class="plan-step-buttons">
                        <TabChangeButton
                            :prevButton="activeIndex > 0"
                            :nextButton="activeIndex <= stepperData.length - 3"
                            @nextPage="() => (activeIndex === stepperData.length - 1 ? '' : (activeIndex += 1))"
                            @prevPage="() => (activeIndex > 0 ? (activeIndex = activeIndex - 1) : '')"
                        />
                    </div>
                </div>
                <div class="stepper-slider">
                    <Stepper :activeTab="activeIndex" @changeTab="(i) => (activeIndex = i)" :tabInfo="stepperData" />
                </div>
            </div>
            <div class="body">
                <div class="package-control" :class="[activeIndex == 0 ? 'end' : 'between']">
                    <div class="change-plan" v-if="activeIndex < 3">
                        <ChangePlan
                            v-model="subscribes['supsis'].period"
                            @plan-changed="(period) => periodChange('supsis', period)"
                            v-if="activeIndex === 0"
                        />
                        <ChangePlan
                            v-model="subscribes['chatbot'].period"
                            @plan-changed="(period) => periodChange('chatbot', period)"
                            v-if="activeIndex === 1"
                        />
                        <ChangePlan
                            v-model="subscribes['whatsapp'].period"
                            @plan-changed="(period) => periodChange('whatsapp', period)"
                            v-if="activeIndex === 2"
                        />
                        <ChangePlan
                            v-model="subscribes['whatsapp-business'].period"
                            @plan-changed="(period) => periodChange('whatsapp-business', period)"
                            v-if="activeIndex === 3"
                        />
                    </div>
                    <div class="agent-slider" v-if="activeIndex == 0">
                        <div class="agent-title">Temsilci Sayısı</div>
                        <div class="agent-content">
                            <a-slider
                                v-model="subscribes['supsis'].details.agentCount"
                                :min="1"
                                :max="200"
                                class="slider"
                            />
                            <a-input-number
                                v-model="subscribes['supsis'].details.agentCount"
                                :min="1"
                                :max="200"
                                class="counter"
                            />
                        </div>
                    </div>
                    <div class="agent-slider" v-if="activeIndex == 2">
                        <div class="agent-title">Kanal Sayısı</div>
                        <div class="agent-content">
                            <a-slider
                                v-model="subscribes['whatsapp'].details.whatsappChannel"
                                :min="1"
                                :max="100"
                                class="slider"
                            />
                            <a-input-number
                                v-model="subscribes['whatsapp'].details.whatsappChannel"
                                :min="1"
                                :max="100"
                                class="counter"
                            />
                        </div>
                    </div>
                    <div class="agent-slider" v-if="activeIndex == 3">
                        <div class="agent-title">Kanal Sayısı</div>
                        <div class="agent-content">
                            <a-slider
                                v-model="subscribes['whatsapp-business'].details.whatsappChannel"
                                :min="1"
                                :max="100"
                                class="slider"
                            />
                            <a-input-number
                                v-model="subscribes['whatsapp-business'].details.whatsappChannel"
                                :min="1"
                                :max="100"
                                class="counter"
                            />
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div style="display: flex; justify-content: center; align-items: center">
                        <Card
                            v-for="plan of allPlans['supsis']"
                            :plan="plan"
                            v-if="activeIndex === 0"
                            @subscribe="addSubscribe"
                            :key="plan._id"
                            :period="subscribes['supsis'].period"
                            :details="subscribes['supsis'].details"
                            :wizard="true"
                            :isSelected="
                                subscribes['supsis'].plan
                                    ? subscribes['supsis'].plan.details.agentCount ==
                                          subscribes['supsis'].details.agentCount &&
                                      subscribes['supsis'].plan &&
                                      subscribes['supsis'].plan._id == plan._id
                                    : plan.isFreePlan
                            "
                        />
                        <Card
                            v-for="plan of allPlans['chatbot']"
                            :plan="plan"
                            v-if="activeIndex === 1"
                            @subscribe="addSubscribe"
                            :key="plan._id"
                            :period="subscribes['chatbot'].period"
                            :wizard="true"
                            :isSelected="
                                subscribes['chatbot'].plan
                                    ? subscribes['chatbot'].plan && subscribes['chatbot'].plan._id == plan._id
                                    : plan.isFreePlan
                            "
                        />
                        <Card
                            v-for="plan of allPlans['whatsapp']"
                            :plan="plan"
                            v-if="activeIndex === 2"
                            @subscribe="addSubscribe"
                            :key="plan._id"
                            :period="subscribes['whatsapp'].period"
                            :details="subscribes['whatsapp'].details"
                            :wizard="true"
                            :isSelected="
                                subscribes['whatsapp'].plan
                                    ? subscribes['whatsapp'].plan.details.whatsappChannel ==
                                          subscribes['whatsapp'].details.whatsappChannel &&
                                      subscribes['whatsapp'].plan &&
                                      subscribes['whatsapp'].plan._id == plan._id
                                    : plan.isFreePlan
                            "
                        />
                        <Card
                            v-for="plan of allPlans['whatsapp-business']"
                            :plan="plan"
                            v-if="activeIndex === 3"
                            @subscribe="addSubscribe"
                            :key="plan._id"
                            :period="subscribes['whatsapp-business'].period"
                            :details="subscribes['whatsapp-business'].details"
                            :wizard="true"
                            :isSelected="
                                subscribes['whatsapp-business'].plan
                                    ? subscribes['whatsapp-business'].plan.details.whatsappChannel ==
                                          subscribes['whatsapp-business'].details.whatsappChannel &&
                                      subscribes['whatsapp-business'].plan &&
                                      subscribes['whatsapp-business'].plan._id == plan._id
                                    : plan.isFreePlan
                            "
                        />
                        <!-- <Card
                            v-for="plan of allPlans['instagram']"
                            :plan="plan"
                            v-if="activeIndex === 4"
                            @subscribe="addSubscribe"
                            :key="plan._id"
                            :period="subscribes['instagram'].period"
                            :wizard="true"
                            :isSelected="
                                (subscribes['instagram'].plan && subscribes['instagram'].plan._id == plan._id) ||
                                plan.isFreePlan
                            "
                        /> -->
                    </div>
                    <div class="preview" v-if="activeIndex === 4">
                        <SubscriptionCard
                            v-for="key of Object.keys(subscribes).filter((x) => subscribes[x].plan)"
                            :subscribe="subscribes[key]"
                            :details="subscribes[key].details || {}"
                            :key="key"
                            @deletePlan="deletePlan(subscribes[key].plan)"
                        />
                    </div>
                    <div v-if="activeIndex === 4" class="skip-preview">
                        <div class="skip-preview-button" @click="activeIndex = activeIndex + 1">Ön İzlemeyi Geç</div>
                    </div>
                    <div class="payment" v-if="activeIndex === 5">
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                flex-direction: column;
                                margin-bottom: 15px;
                                width: 100%;
                            "
                        >
                            <CreditCardForm
                                v-if="sitePaymentMethod === 'credit-card'"
                                @input="(val) => (cardForm = val)"
                                style="width: 80%; margin-bottom: 15px"
                            />
                            <BillingAddressForm @input="(val) => (billingAddressForm = val)" style="width: 80%" />
                        </div>
                        <div>
                            <TotalCost
                                :subscribes="subscribes"
                                @submit="complateWizard"
                                :disableComplateButton="disableComplateButton"
                            />
                        </div>
                    </div>
                    <PlanSelectionCompleted @clickHandler="goBillingPage()" v-if="activeIndex === 6" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Stepper from "../../../../components/billing/new/Stepper.vue";
import ChangePlan from "../../../../components/billing/new/ChangePlan.vue";
import Card from "../../../../components/billing/Card.vue";
import SubscriptionCard from "../../../../components/billing/new/SubscriptionCard.vue";
import CreditCardForm from "../../../../components/billing/new/CreditCardForm.vue";
import BillingAddressForm from "../../../../components/billing/new/BillingAddressForm.vue";
import TotalCost from "../../../../components/billing/new/TotalCost.vue";
import PlanSelectionCompleted from "../../../../components/billing/new/PlanSelectionCompleted.vue";
import TabChangeButton from "../../../../components/billing/new/TabChangeButtton.vue";
import { message } from "ant-design-vue";
import { mapState, mapActions } from "vuex";
import { sendSocketMessage } from "../../../../utils/socketStream";

const { updateBilling } = require("../../../../api/billing");

export default {
    name: "BillingWizard",
    components: {
        Stepper,
        ChangePlan,
        Card,
        SubscriptionCard,
        CreditCardForm,
        BillingAddressForm,
        TotalCost,
        PlanSelectionCompleted,
        TabChangeButton,
    },
    data() {
        return {
            disableComplateButton: false,

            subscribes: {
                supsis: {
                    icon: "CSupsis",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        agentCount: 1,
                    },
                },
                chatbot: {
                    icon: "CChatbot",
                    period: "monthly",
                    plan: null,
                    price: 0,
                },
                instagram: {
                    icon: "Instagram",
                    period: "monthly",
                    plan: null,
                    price: 0,
                },
                whatsapp: {
                    icon: "CWhatsapp",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        whatsappChannel: 1,
                    },
                },
                "whatsapp-business": {
                    icon: "CWhatsappBusiness",
                    period: "monthly",
                    plan: null,
                    price: 0,
                    details: {
                        whatsappChannel: 1,
                    },
                },
            },
            cardForm: null,
            billingAddressForm: null,
            activeIndex: 0,
            stepperData: [
                {
                    logo: "SelectPlan",
                    isComplete: false,
                    title: "Plan Seçimi",
                    isSelectable: true,
                },
                {
                    logo: "Chatbot",
                    isComplete: false,
                    title: "Chatbot",
                    isSelectable: true,
                },
                {
                    logo: "Whatsapp",
                    isComplete: false,
                    title: "Whatsapp",
                    isSelectable: true,
                },
                {
                    logo: "Whatsapp",
                    isComplete: false,
                    title: "Whatsapp Business",
                    isSelectable: true,
                },
                {
                    logo: "Binoculars",
                    isComplete: false,
                    title: "Önizleme",
                    isSelectable: true,
                },
                {
                    logo: "CreditCard",
                    isComplete: false,
                    title: "Ödeme",
                    isSelectable: true,
                },
                {
                    logo: "Vector",
                    isComplete: false,
                    title: "Tamamlandı",
                    isSelectable: false,
                },
            ],
            monthlyCost: {
                subscribes: [],
                total: 0,
            },
            annualCost: {
                subscribes: [],
                total: 0,
            },
        };
    },
    methods: {
        ...mapActions({
            createPaymentMethod: "site/createPaymentMethod",
            subscribePlan: "site/subscribePlan",
            setSettingValue: "setting/setSettingValue",
            updateSettings: "setting/updateSettings",
        }),
        async setWizardAsCompleted() {
            const newSettings = await this.setSettingValue({
                setting: "planWizardCompleted",
                value: true,
            });
            this.updateSettings(newSettings).then(() => {
                this.disableComplateButton = false;
                sendSocketMessage("admin settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
        addSubscribe(payload) {
            const plan = this.allPlansById[payload.planId];
            const subscribe = this.subscribes[plan.type];
            this.subscribes[plan.type].plan = {
                ...plan,
                details: { ...subscribe.details },
            };
            this.activeIndex += 1;
            this.subscribes[plan.type].price =
                this.subscribes[plan.type].period == "annual"
                    ? (plan.price * 12 * (100 - plan.yearlyDiscount)) / 100
                    : plan.price;

            if (plan.type == "supsis") {
                if (plan.isFreePlan) subscribe.details.agentCount = 1;
                this.subscribes[plan.type].price =
                    this.subscribes[plan.type].period == "annual"
                        ? (plan.price * subscribe.details.agentCount * 12 * (100 - plan.yearlyDiscount)) / 100
                        : subscribe.details.agentCount * plan.price;
            } else if (plan.type == "whatsapp") {
                this.subscribes[plan.type].price =
                    this.subscribes[plan.type].period == "annual"
                        ? (plan.price * subscribe.details.whatsappChannel * 12 * (100 - plan.yearlyDiscount)) / 100
                        : subscribe.details.whatsappChannel * plan.price;
            } else if (plan.type == "whatsapp-business") {
                this.subscribes[plan.type].price =
                    this.subscribes[plan.type].period == "annual"
                        ? (plan.price * subscribe.details.whatsappChannel * 12 * (100 - plan.yearlyDiscount)) / 100
                        : subscribe.details.whatsappChannel * plan.price;
            }
        },
        deletePlan(plan) {
            console.log("deleted plan", { plan });
            const freePlan = this.allPlans[plan.type].find((p) => p.isFreePlan);
            this.subscribes[plan.type].plan = freePlan
                ? {
                      ...freePlan,
                      details: {
                          agentCount: 1,
                      },
                  }
                : null;
            this.subscribes[plan.type].price = 0;
            if (["whatsapp-business", "whatsapp"].includes(plan.type)) {
                this.subscribes[plan.type].details = {
                    whatsappChannel: 1,
                };
            }
            if (plan.type == "supsis") {
                this.subscribes[plan.type].details = {
                    agentCount: 1,
                };
            }
        },
        complateWizard(couponCode) {
            const { userAgreement, name, cardNumber, type, skt, cvv, newCardForm } = this.cardForm || {};
            const {
                name: billAdressName,
                surname,
                idenity,
                mail,
                country,
                city,
                address,
                isCompany,
            } = this.billingAddressForm || {};

            const totalPrice = Object.keys(this.subscribes).reduce((acc, sub) => {
                const plan = this.subscribes[sub];
                acc += plan.price;
                return acc;
            }, 0);

            if (
                this.sitePaymentMethod === "credit-card" &&
                totalPrice > 0 &&
                newCardForm &&
                (!name?.length || !cardNumber?.length || !type?.length || !skt?.length || !cvv?.length)
            ) {
                return message.error("Lütfen kart bilgilerini doldurunuz!");
            }
            if (this.sitePaymentMethod === "credit-card" && totalPrice > 0 && newCardForm && cardNumber?.length < 16) {
                return message.error("Kart Numarası Hatalıdır!");
            }
            if (this.sitePaymentMethod === "credit-card" && totalPrice > 0 && !userAgreement) {
                return message.error("Lütfen kullanıcı sözleşmesini onaylayınız.");
            }

            if (
                totalPrice > 0 &&
                (!billAdressName?.length ||
                    (!isCompany && !surname?.length) ||
                    !idenity?.length ||
                    !mail?.length ||
                    !country?.length ||
                    !city?.length ||
                    !address.length)
            ) {
                return message.error("Fatura addresi bilgilerini doldurunuz!");
            }

            this.disableComplateButton = true;
            if (totalPrice > 0) {
                updateBilling({
                    name: billAdressName,
                    surname,
                    billingAddress: address,
                    billingCity: city,
                    billingContactName: billAdressName,
                    billingCountry: country,
                    email: mail,
                    identityNumber: idenity,
                    billingType: isCompany ? "company" : "individual",
                });
                (this.sitePaymentMethod !== "credit-card" || (this.billingDetail && !newCardForm)
                    ? Promise.all([])
                    : this.createPaymentMethod({
                          name: name.split(" ")[0],
                          surname: name.split(" ")[0],
                          billingAddress: address,
                          billingCity: city,
                          billingCountry: country,
                          email: mail,
                          identityNumber: idenity,
                          billingContactName: billAdressName,
                          contactName: billAdressName,
                          cardAlias: cvv,
                          cardNumber: cardNumber.split(" ").join(""),
                          cardHolderName: name,
                          expireMonth: skt.split("/")[0],
                          expireYear: skt.split("/")[1],
                      })
                )
                    .then(async (billingDetail) => {
                        billingDetail = billingDetail || this.billingDetail;
                        if (billingDetail && billingDetail.iyzicoCardToken) {
                            this.activeIndex += 1;
                        }
                        Object.keys(this.subscribes).forEach((sub) => {
                            const plan = this.subscribes[sub].plan;
                            if (plan) {
                                let payload = { planId: plan._id, period: this.subscribes[sub].period };
                                if (["supsis", "whatsapp", "whatsapp-business"].includes(sub)) {
                                    payload.details = this.subscribes[sub].details;
                                }
                                this.subscribePlan(payload);
                            }
                        });
                        this.setWizardAsCompleted();
                    })
                    .catch((err) => {
                        console.error("BillingWizard.createPaymentMethod", err);
                        //TODO: err kısmından kartın bakiyesimi yok yada kart kapalımı dönüyor...
                        this.$toasted.error("Lütfen kartınızı ve bilgilerinizi kontrol ediniz.", {
                            duration: 3000,
                            position: "bottom-center",
                        });
                        this.disableComplateButton = false;
                    });
            } else {
                this.setWizardAsCompleted();
            }
        },
        tabChangeHandler() {
            this.stepperData.map((step, index) => {
                if (this.activeIndex < index || this.activeIndex === index) {
                    step.isComplete = false;
                    return;
                }
                if (this.activeIndex > index) {
                    step.isComplete = true;
                    return;
                }
            });
        },
        goBillingPage() {
            this.$router.push("/billing");
        },
        periodChange(type, period) {
            console.log("period changed", { type, period, subscribe: this.subscribes[type] });
            this.subscribes[type].period = period;
            if (this.subscribes[type].plan) {
                this.deletePlan(this.subscribes[type].plan);
            }
        },
    },
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
            allPlans: (state) =>
                _.groupBy(
                    state.site.plans.filter((p) => !p.isDeleted),
                    (plan) => plan.type
                ),
            allPlansById: (state) =>
                state.site.plans
                    .filter((p) => !p.isDeleted)
                    .reduce((acc, plan) => {
                        acc[plan._id] = plan;
                        return acc;
                    }, {}),
            plans: (state) => state.site.plans.filter((p) => !p.isDeleted),
            site: (state) => state.site.site,
            sitePaymentMethod: (state) => state.site.site?.paymentMethod || "credit-card",
        }),
        selectedTab() {
            return this.stepperData[this.activeIndex];
        },
    },
    watch: {
        activeIndex(val) {
            if (val == 1 && !this.subscribes["supsis"].plan) {
                const supsisPlan = (this.allPlans["supsis"] || []).find((p) => p.isFreePlan);
                this.subscribes["supsis"].plan = {
                    details: {
                        agentCount: 1,
                    },
                    ...supsisPlan,
                };
            }
            this.tabChangeHandler();
        },
    },
};
</script>
<style lang="scss">
#billing-wizard {
    .agent-slider {
        .ant-slider-handle {
            background: rgb(236, 75, 29);
            border-color: rgb(236, 75, 29);

            :focus {
                box-shadow: none;
                -webkit-box-shadow: none;
            }
        }

        .ant-slider-track {
            background: rgb(236, 75, 29);
            height: 8px !important;
        }

        .ant-slider-rail {
            height: 8px !important;
        }

        .ant-slider-handle {
            width: 17px !important;
            height: 17px !important;
            margin-top: -4px !important;
        }
    }
}
</style>
<style lang="scss" scoped>
#billing-wizard {
    width: 100%;
    min-height: 100vh;
    background-color: white;
    padding: 0px 50px;
    padding-bottom: 10px;

    .skip-preview {
        display: flex;
        align-items: center;
        justify-content: center;
        .skip-preview-button {
            background-color: #ec4b1d;
            color: white;
            padding: 10px 15px;
            font-weight: bold;
            border-radius: 20px;
            cursor: pointer;
        }
    }

    .setup {
        .header {
            .title {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .plan-steps {
                display: flex;
                font-size: 22px;
                color: #1f1f1f;
                font-weight: 600;

                span {
                    color: #848484;
                    margin-left: 10px;
                    font-size: 16px;
                }
            }
        }

        .body {
            margin-top: 30px;

            .package-control {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .agent-title {
                    font-weight: bold;
                }

                .agent-content {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .slider {
                        width: 400px;
                    }

                    .counter {
                        margin-left: 5px;
                        border-radius: 14px;
                        width: 65px;
                    }
                }
            }

            .content {
                margin-top: 20px;

                .preview {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-wrap: wrap;

                    div {
                        margin-right: 5px;
                        margin-bottom: 20px;

                        :last-child {
                            margin-right: 0;
                            margin-bottom: 0;
                        }
                    }
                }

                .payment {
                    display: flex;
                    justify-content: space-evenly;
                    margin-top: 20px;
                    margin-bottom: 20px;
                    width: 100%;
                }
            }
        }
    }

    .general-status {
        .body {
            .invoice-payment {
                display: flex;
                justify-content: space-around;
            }
        }
    }
}

@media only screen and (max-width: 900px) {
    .stepper-slider {
        display: none !important;
    }
}
</style>
